import config from '../config';
import axios from 'axios';
import Auth0SessionInfo from './Auth0SessionInfo';

// ─── Shard Management ────────────────────────────────────────────────

const getBackofficeApi = () => {
  const token = Auth0SessionInfo.GetSessionInfo().accessToken;
  return axios.create({
    baseURL: `${config.apim.url}/backoffice`,
    timeout: 900000,
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
  });
};

const getPayload = (responseOrError) => responseOrError?.data?.Content || responseOrError?.data || responseOrError?.response?.data?.Content || responseOrError?.response?.data;

const hasDurableTrackingPayload = (payload) => {
  const instanceId = payload?.Id || payload?.id || payload?.instanceId;
  const statusQueryGetUri = payload?.StatusQueryGetUri || payload?.statusQueryGetUri;

  return Boolean(instanceId && statusQueryGetUri);
};

export const getShardMappings = async () => {
  const api = getBackofficeApi();
  const response = await api.get('/GetShardList');
  return response.data;
};

export const addShardMapping = async (addShardPayload) => {
  const api = getBackofficeApi();
  try {
    const response = await api.post('/RequestShardAddition', addShardPayload);
    return getPayload(response);
  } catch (error) {
    const payload = getPayload(error);
    if (hasDurableTrackingPayload(payload)) {
      return payload;
    }
    throw error;
  }
};

export const removeShardMapping = async (removeShardPayload) => {
  const api = getBackofficeApi();
  try {
    const response = await api.post('/RequestShardRemoval', removeShardPayload);
    return getPayload(response);
  } catch (error) {
    const payload = getPayload(error);
    if (hasDurableTrackingPayload(payload)) {
      return payload;
    }
    throw error;
  }
};

export const getDurableFunctionStatus = async (statusQueryGetUri) => {
  const token = Auth0SessionInfo.GetSessionInfo().accessToken;
  try {
    const response = await axios.get(statusQueryGetUri, {
      headers: { authorization: `Bearer ${token}` },
      timeout: 30000,
    });
    return getPayload(response);
  } catch (error) {
    const payload = getPayload(error);
    if (payload?.runtimeStatus || payload?.RuntimeStatus) {
      return payload;
    }
    throw error;
  }
};
